import PropTypes from "prop-types";

const Error = (props) => {
  switch (props.error) {
    case "invalidIframe":
      return <h1 className="error">Embed code is invalid.</h1>;

    case "videoUnavailable":
      return <h1 className="error">Failed to load video source.</h1>;

    default:
      return <h1 className="error">Something went wrong.</h1>;
  }
};

Error.propTypes = {
  error: PropTypes.string,
};

export default Error;
